import { render, staticRenderFns } from "./sealwidthAndHeight.vue?vue&type=template&id=3377c6af&scoped=true"
import script from "./sealwidthAndHeight.vue?vue&type=script&lang=js"
export * from "./sealwidthAndHeight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3377c6af",
  null
  
)

export default component.exports